export default __webpack_public_path__ + "static/media/AdobeStock_320542224.45565316.jpg";